import { Component } from '@angular/core'
import { HeaderComponent } from '../header/header.component'
import { MatButtonModule } from '@angular/material/button'
import { RouterLink } from '@angular/router'
import { FormMarketingDeskComponent } from '../form-marketing-desk/form-marketing-desk.component'
import { CommonModule } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'app-home-marketing-desk',
  standalone: true,
  templateUrl: './home-marketing-desk.component.html',
  styleUrl: './home-marketing-desk.component.scss',
  imports: [
    HeaderComponent,
    MatButtonModule,
    RouterLink,
    FormMarketingDeskComponent,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonToggleModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class HomeMarketingDeskComponent {
  showForm = false
  showPrereq = false
}
